import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext();
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = unauthenticated
  const [tenant, setTenant] = useState(null);

  const loadMe = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setTenant(data.tenant);
    } catch (e) {
      setUser(false);
      setTenant(null);
    }
  };

  useEffect(() => {
    loadMe();
    // eslint-disable-next-line
  }, []);

  const login = async (email, password, remember) => {
    // Backend sets httpOnly auth cookies; we do not store tokens in JS.
    const { data } = await api.post("/auth/login", { email, password, remember });
    setUser(data.user);
    if (data.user.tenant_id) {
      const me = await api.get("/auth/me");
      setTenant(me.data.tenant);
    }
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) {}
    setUser(false);
    setTenant(null);
  };

  return (
    <AuthContext.Provider value={{ user, tenant, setTenant, login, logout, reload: loadMe }}>
      {children}
    </AuthContext.Provider>
  );
}
